import { boot as bootFeature } from 'lib/feature'
import getProp from '@f/get-prop'
import Raven from 'raven-js'

export default (workspaceId) => {
  const { segment } = window

  // Pass release and environment info to Sentry after it is loaded
  window.analytics.ready(() => {
    const { FS } = window

    // Include fullstory link in Sentry extras.
    // FullStory does not include `getCurrentSessionURL` in it's initialize snippet
    // so we need to use their global `window._fs_ready` if the library has yet to load.
    if (FS && FS.getCurrentSessionURL) {
      addFullStoryUrl()
    } else {
      window._fs_ready = addFullStoryUrl
    }
  })
  return bootFeature({ key: segment.splitioKey, workspaceId: workspaceId || getProp('workspace.id', segment) })
}

function addFullStoryUrl () {
  const { FS } = window
  if (FS && FS.getCurrentSessionURL) {
    const linkToNow = true
    Raven.setExtraContext({ fullstory: FS.getCurrentSessionURL(linkToNow) })
  }
}



// WEBPACK FOOTER //
// ./lib/boot.js